// extracted by mini-css-extract-plugin
export default {"fontSpan":"invoice_fontSpan__eXD45"};